module.exports = __webpack_public_path__ + "static/media/Register-1.861e0879.svg";